import styled from 'styled-components';

import { Box } from 'components/Box';
import { cssBreakpoints, gutterWidth } from 'theme/theme';

export const CmsFourArticlesHighlightBlockPageSectionBox = styled(Box)`
  @media all and (max-width: ${cssBreakpoints.smDown}) {
    &:not(:first-child) {
      margin-top: ${(gutterWidth * 3) / 4}px;
    }
  }
  @media all and (min-width: ${cssBreakpoints.smDown}) and (max-width: ${cssBreakpoints.mdDown}) {
    &:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: ${gutterWidth}px;
    }
  }

  a {
    position: relative;
    display: block;
    max-width: 240px;
  }
`;
